import { render } from "./CrmRedeemNowCard.vue?vue&type=template&id=f3a5931c&scoped=true"
import script from "./CrmRedeemNowCard.vue?vue&type=script&lang=js"
export * from "./CrmRedeemNowCard.vue?vue&type=script&lang=js"

import "./CrmRedeemNowCard.vue?vue&type=style&index=0&id=f3a5931c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3a5931c"]])

export default __exports__